<template>
  <div :style="'height: 100% !important'">
    <div class="px-4 py-3">
      <h2 class="text-center mb-5">{{ $t('servicesystem.common_objects.customer.select_customer') }}</h2>

      <text-field-timeout v-model="filtercus" outlined clearable hide-details :loading="loading || eventualDataLoading"
        :label="$t('servicesystem.common_objects.customer.search_field_label')">
        <template v-slot:append-outer>
          <HoverMenu :direction="'bottom'">
            <template v-slot:menu-activator>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon>
                    <v-icon size="20" v-text="'mdi-cog'" v-bind="attrs" v-on="on">
                    </v-icon>
                  </v-btn>
                </template>
                <span v-text="$t('servicesystem.common_objects.commonterms.search_settings')" />
              </v-tooltip>
            </template>

            <template v-slot:menu-content>
              <switch-li :label="$t('servicesystem.pages.site_settings.show_inactive_customers')"
                v-model="ShowInactiveCustomers" :edit="true" class="mr-2">
              </switch-li>
            </template>
          </HoverMenu>

        </template>
      </text-field-timeout>
    </div>
    <div v-if="searchStartCharLimit && Searching" class="scrolllist"
      :style="isPhoneBool ? 'max-height: calc(100% - 207px);' : 'max-height: calc(100% - 137px);'">
      <v-list v-if="customerlist && customerlist.length > 0" class="py-0 OddMarkedList">
        <CustomerListItem v-for="item in customerlist" :key="item.Id"
          v-show="ShowInactiveCustomers ? true : item.IsActive" :item="item"
          :preselected="$route.query.customerId == item.Id" previewable @click="openItem(item)"
          @openPreview="openPreview(item)" @closePreview="closePreview(true)">
        </CustomerListItem>
      </v-list>
      <div v-else class="px-12 text-center">
        <template v-if="!loading">
          {{ $t('servicesystem.common_objects.fallbackterms.no_items_found_by_term', { qkey: filtercus }) }}
          <br>
          <NewCustomerBtn>
          </NewCustomerBtn>
        </template>
        <template v-else>
          {{ $t('servicesystem.common_objects.commonterms.searching') }}
        </template>
      </div>
    </div>
    <div v-else class="px-12 text-center">
      {{ $t('servicesystem.common_objects.commonterms.search_placeholder', {
        qkey:
          ($t('servicesystem.common_objects.customer.customer').toLocaleLowerCase())
      }) }}
    </div>

    <NewCustomerDialog :externaltrigger="$store.state.triggerevents.newDialogTrigger" :name="filtercus"
      @Created="openItem">
    </NewCustomerDialog>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import NewCustomerBtn from "@/components/Buttons/NewCustomerBtn.vue";
import NewCustomerDialog from "@/components/Dialogs/NewCustomerDialog.vue";
import TextFieldTimeout from "@/components/Inputs/Parts/TextFieldTimeout.vue";
import SwitchLi from "@/components/Inputs/SwitchListItem.vue";
import CustomerListItem from "@/components/ListItems/CustomerListItem.vue";
import HoverMenu from "@/components/Menus/HoverMenu.vue";
import EventualDataMixin from "@/helpers/Mixins/EventualDataMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";

export default {
  name: "CustomerList",
  props: ["searchStartCharLimit", "right", "heightlimit"],
  components: {
    CustomerListItem,
    TextFieldTimeout,
    HoverMenu,
    SwitchLi,
    NewCustomerBtn,
    NewCustomerDialog,
  },
  mixins: [clientAPI, EventualDataMixin],

  data() {
    return {
      filtercus: "",
      selcus: null,
      loading: false,
      eventualDataLoading: false,
      customerlist: [],
    };
  },

  mounted() {
    this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
    this._boundEventualDataHandler = (args) => this.notifyChanges(args);
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.EventualDataEvent,
      this._boundEventualDataHandler
    ]);
  },

  beforeDestroy() {
    this.clearEventualDataTimeout();
    if (this._boundEventualDataHandler) {
      this.$store.dispatch("NotificationStore/unsubscribe", [
        SRConst.EventKeys.EventualDataEvent,
        this._boundEventualDataHandler
      ]);
    }
  },

  methods: {
    notifyChanges(args) {
      if (!this.eventualDataLoading) return;
      if (this.mergeEventualDataIntoList(args, SRConst.EventualDataType.Customer, this.customerlist)) {
        this.eventualDataLoading = false;
      }
    },

    searchCustomers() {
      this.loading = true;
      this.eventualDataLoading = false;
      this.clearEventualDataTimeout();
      this.searchCustomersByString(this.filtercus)
        .then((response) => {
          this.customerlist = response;
          this.loading = false;
          var eventualDataMode = this.$store.state.ERPConfig.EventualDataMode;
          var connected = this.$store.getters['NotificationStore/connectionState'] === 'Connected';
          if (eventualDataMode && connected) {
            this.eventualDataLoading = true;
            this.scheduleEventualDataTimeout(() => {
              if (this.eventualDataLoading) this.eventualDataLoading = false;
            });
          }
        })
        .catch((exception) => console.error(exception));
    },

    openPreview(item) {
      var query = Object.assign({}, this.$route.query);
      query.customerId = item.Id;
      this.$router.replace({ query });
      this.$store.dispatch("JobHub/JobPreview/getPreviewCustomer", item.Id);
    },

    closePreview(clearStore) {
      var query = Object.assign({}, this.$route.query);
      query.customerId = undefined;
      this.$router.replace({ query });
      if (clearStore) { this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null); }

    },

    async openItem(item) {
      if (this.$route.name === "NewJobStart") {
        this.closePreview();
        this.$router.push({ name: "NewJobOverview", query: { customerId: item.Id, picker: 'machine' } });
      }
      this.$emit("Close");
    },
  },

  computed: {
    PreviewCustomer() {
      return this.$store.getters["JobHub/PreviewCustomer"];
    },

    Searching() {
      if (!this.searchStartCharLimit) { return this.filtercus && this.filtercus.length > 0; }
      else { return this.filtercus && this.filtercus.length >= this.searchStartCharLimit; }
    },

    ShowInactiveCustomers: {
      get() { return this.$store.getters["prefrences/Prefrence"]("ShowInactiveCustomers"); },
      set(update) { this.$store.dispatch("prefrences/set_prefrence", { key: "ShowInactiveCustomers", value: update }); },
    },
  },

  watch: {
    filtercus: function () {
      if (this.searchStartCharLimit) {
        if (this.filtercus.length < this.searchStartCharLimit) {
          this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
        } else {
          this.searchCustomers();
        }
      } else {
        if (!this.filtercus || (this.filtercus && this.filtercus.length < 1)) {
          this.$store.dispatch("JobHub/JobPreview/setPreviewCustomer", null);
        } else {
          this.searchCustomers();
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.selectbtndiv {
  position: sticky;
  padding-top: 10px;
  padding-bottom: 10px;
  bottom: 0;
  z-index: 20;
  pointer-events: none;
}

.selectbtndiv button {
  pointer-events: auto;
}

.scrolllist {
  overflow-y: overlay;
  overflow-x: hidden;
}

@-moz-document url-prefix() {

  //Firefox does not support overlay overflow, and interprets it as none instead of auto.
  .scrolllist {
    overflow-y: auto;
  }
}
</style>